import { OfficeHeader, Tabs } from "components";

import Associates from "./tabs/associates";
import { FC } from "react";
import { LocationGenerics } from "router/location";
import OfferParticipation from "./tabs/participation";
import YearPicker from "layouts/calendar-wrapper/year-picker";
import _ from "lodash";
import { useKEKReInsurer } from "hooks/data/use-re-insurers";
import { useMatch } from "react-location";
import { useUrlState } from "utils";

type Props = {};

const tabs = [{ name: "Associates", href: "associates" }];

const ReInsurerPage: FC<Props> = () => {
  const { params } = useMatch<LocationGenerics>();
  const [orderStatus] = useUrlState("orderStatus");

  const { reInsurer, loading: loadingReinsirer } = useKEKReInsurer(
    params.reInsurer as string
  );

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader renderActions={() => <YearPicker />} />
      <header>
        <div className="flex flex-col items-start justify-between gap-x-8 gap-y-4 bg-background-500 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
          <div>
            <div className="flex items-center gap-x-3">
              <div className="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
                <div className="h-2 w-2 rounded-full bg-current" />
              </div>
              <h1 className="flex gap-x-3 text-base leading-7">
                <span className="font-semibold text-primary">
                  {loadingReinsirer
                    ? "loading ..."
                    : reInsurer?.re_company_name}
                </span>
                <span className="text-gray-600">/</span>
                <span className="font-semibold text-primary">
                  {loadingReinsirer ? "..." : reInsurer?.re_abbrv}
                </span>
              </h1>
            </div>
            <p className="mt-2 text-xs leading-6 text-tertiary">
              {reInsurer?.re_company_email} / {reInsurer?.re_company_website}
            </p>
          </div>
          <div className="order-first flex-none rounded-full bg-indigo-400/10 px-2 py-1 text-xs font-medium text-indigo-400 ring-1 ring-inset ring-indigo-400/30 sm:order-none">
            Active
          </div>
        </div>
      </header>
      <Tabs tabs={tabs} orderStatus={orderStatus} defaultTab="Offers" />
      <>
        {!orderStatus && <OfferParticipation />}
        {orderStatus === "associates" && <Associates />}
      </>
    </main>
  );
};

export default ReInsurerPage;
